import React from 'react';
import { Card } from 'antd';
import { connect } from 'dva';
import GoodsDetailModal from 'components_business/GoodsDetailModal/Index.js';
import SearchForm from './SearchForm.js';
import SelectedCommodities from './SelectedCommodities.js';
import Table from './Table.js';
import OperationButtons from './OperationButtons.js';
import styles from './Index.less';

@connect(({ operationChargeItemPublishChargeItemSteps }) => ({
  searchParams: operationChargeItemPublishChargeItemSteps.searchParams,
  pagination: operationChargeItemPublishChargeItemSteps.pagination,
  publishSchool: operationChargeItemPublishChargeItemSteps.publishSchool,
}))
export default class Step1 extends React.Component {
  constructor(props) {
    super(props);

    this.fetch = this.fetch.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleTableChange = this.handleTableChange.bind(this);
  }

  handleSearch(searchParams) {
    this.fetch({ searchParams });
  }

  handleTableChange(pagination) {
    this.fetch({ pagination });
  }

  fetch({ searchParams = null, pagination = null } = {}) {
    this.props.dispatch({
      type: 'operationChargeItemPublishChargeItemSteps/fetchDataSource',
      searchParams: searchParams || this.props.searchParams,
      pagination: pagination || this.props.pagination,
      orgId: this.props.publishSchool.key,
    });
  }

  render() {
    return (
      <Card bordered={false} className={styles.root}>
        <SearchForm onSearch={this.handleSearch} />
        <SelectedCommodities />
        <Table onChange={this.handleTableChange} />
        <OperationButtons />
        <GoodsDetailModal />
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Operation/ChargeItem/PublishChargeItemSteps/Step1/Index.js